<script setup>
import {ref} from "vue";
import {useTicketStore} from "../../store/tickets";
import {useModalStore} from "../../store/modal";
import {useChatStore} from "../../store/chat.js";

const modalStore = useModalStore()
const ticketStore = useTicketStore()
const chatStore = useChatStore()
const props = defineProps({
    icon: {
        type: String,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    subTitle: {
        type: String,
        required: true,
    },
    action: {
        type: String,
        required: false,
    },
    content: {
        type: String,
        required: false,
    },
    type: {
        type: String,
        default: 'ticket',
        required: false
    }
})

const collapsed = ref(true)
</script>

<template>
    <div class="ticket-info-card" :class="{'--is-collapsed': collapsed}">
        <div class="ticket-info-card-header">
            <ah-icon :name="icon"/>
            <dl>
                <dt>{{ title }}</dt>
                <dd>{{ subTitle }}</dd>
            </dl>
            <router-link :to="`/orders/view/${subTitle}`" class="ticket-card-action" v-if="icon === 'cart-default'">
                View
            </router-link>
            <button
                @click.passive="modalStore.open(type === 'chat' ? 'AssignChat' : 'AssignTicket', {id: type === 'chat' ? chatStore.chat?.id : ticketStore.ticket?.id}, 'body', 'bottom-right')"
                class="ticket-card-action" v-if="icon === 'user-single'">Reassign
            </button>
            <div class="ticket-card-action" v-else-if="content" @click.prevent="collapsed = !collapsed">
                <ah-icon name="chevron-up-down"/>
            </div>
        </div>
        <div class="ticket-info-card-body" v-if="content" v-html="content"></div>
    </div>
</template>

<style lang="scss">
.ticket-info-card {
    background: #fff;
    border-radius: 2.4rem;
    display: grid;
    grid-template-rows: 7.5rem auto;
    overflow: hidden;
    transition: all .2s ease;

    &.--is-collapsed {
        grid-template-rows: 7.5rem 0;
    }

    + .ticket-info-card {
        margin-top: 1rem;
    }

    .ticket-info-card-header {
        display: flex;
        align-items: center;
        min-height: 7.5rem;
        padding: 0 2rem;
        gap: 2rem;

        > .icon {
            fill: var(--color-tiffany-dark);
        }


        dt {
            color: var(--color-thunder);
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            width: calc(100% - 2.4rem);
            @include font(1.4rem, 1.4, black);
            margin-bottom: .5rem;
        }

        dd {
            color: var(--color-thunder);
            @include font(1.4rem, 1.4, book);
        }

        .ticket-card-action {
            margin-left: auto;
            cursor: pointer;
            fill: var(--color-grey-hazy);
            @include font(1.1, null, black);
            color: var(--color-tiffany-dark);
            display: flex;
            align-items: center;

            @include hover() {
                fill: var(--color-tiffany-dark);
            }
        }
    }

    .ticket-info-card-body {
        padding: 2rem;
    }

    button {
        background: var(--color-white);
        border: none;
    }

    @include dark() {
        background: var(--color-darth-maul);

        * {
            color: var(--color-white);
        }
    }
}
</style>
